'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Resource = exports.GenericResource = undefined;

var _superagent = require('./superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _single = require('./single');

var _single2 = _interopRequireDefault(_single);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Export everything
// We use superagent as a default worker
var GenericResource = exports.GenericResource = _superagent2.default;

// import SingleObjectResource factory
var Resource = exports.Resource = (0, _single2.default)(_superagent2.default);


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/dist/generic.js
// module id = 771
// module chunks = 0